var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 6,
    viewBox: "0 0 14 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.466 5.22C9.586 4.908 9.718 4.62 9.862 4.356C10.006 4.08 10.168 3.822 10.348 3.582H0.7V2.106H10.348C10.18 1.866 10.024 1.614 9.88 1.35C9.736 1.074 9.604 0.78 9.484 0.467999H10.852C11.596 1.344 12.412 2.01 13.3 2.466V3.24C12.412 3.672 11.596 4.332 10.852 5.22H9.466Z",
    fill: "#99ACBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.d959cc0914db08e6995ec303624b488b.svg";
export { ForwardRef as ReactComponent };